export const cardPage = {
    "cvv": "3 ספרות בגב הכרטיס",
    "expiry": "תוקף כרטיס",
    "card_number": "מספר כרטיס",
    "future_charge": "החיוב הראשון יתבצע ב {{date}}",
    "total_payable": "סך לתשלום",
    "payment_provider_error": "שגיאה פנימית של ספק התשלומים",
    "payment_error": "שגיאת תשלום, אנא נסה שוב",
};
